<template>
    <div id="toolDrawer">
        <div class="drawer_header">
            <img class="header_icon" src="../views/img/robot.png" >
            <div class="header_content">
                <div class="header_line_one">MJ绘画提示词工具<span class="line_tag">限时免费</span></div>
                <div class="header_line_two">点击下方提示词即可插入绘画，效果更好</div>
            </div>
        </div>
        <div :class="['drawer_content_wrapper', site_skin]">
            <div class="content_nav">
                <div @click="changeNav(index)" :class="['nav_item', { 'active': selectType == index }]" v-for="(tab,index) in tab_list" :key="index">{{ tab }}</div>
            </div> 
            <div ref="refScroll" class="img_lists clearfix" v-if="img_list.length">
                <waterfall ref="waterfall" :col="2" :width="140" :gutterWidth="10" :data="img_list" @loadmore="loadmore" :height="'100%'">
                    <template>
                        <div class="cell_item" v-for="(item, index) in img_list" :key="index">
                            <img class="cell_img" @click="previewImg(item)" :lazy-src="item.img_url+'?width=360&height=360'" alt="加载错误" />
                            <div class="img_info">
                                <div class="info_item">
                                    <img class="info_icon" src="./img/person-time.png" />
                                    <span>{{ item.use_num }}</span>
                                </div>
                                <div class="info_item" @click="selectApplication(item)">
                                    <img class="info_icon" src="./img/tips_icon.png" />
                                    <span class="tips">插入提示词</span>
                                </div>
                            </div>
                        </div>
                        <div class="no_more" v-if="noMore"><span>没有更多了</span></div>
                    </template>
                </waterfall>
            </div>
            <div class="img_empty" v-else>
                <img class="empty_icon" src="./img/empty.jpg" alt="" srcset="">
                <div class="empty_text">暂无任何记录</div>
            </div>
        </div>
        <popup ref="viewPopup" type="center" @close="popClose">
            <img class="view_img" :src="view_img_url+'?width=700&height=700'" alt="">
        </popup>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    export default {
        props:["selectData"],
        components:{popup},
        data() {
            return {
                selectType:0,
                page:1,
                tab_list:["最近使用","热门推荐","热门排行","最新发布"],
                img_list:[],
                view_img_url:"",
                noMore:false,
                site_skin:''
            }
        },
        created(){
            this.site_skin = SiteSkin
            this.getData();
        },
        methods: {
            getData(){
                let tj_cate_id = this.selectType
                if(this.selectType == 0){
                    tj_cate_id = 3
                }else if(this.selectType == 3){
                    tj_cate_id = 4
                }
                this.$http.get('/front/chatai/chatmj/',{params:{
                    tj_cate_id:tj_cate_id,
                    page:this.page
                }}).then(res =>{
                    if(res.status=='200'){
                        let newList = res.data.item_list;
                        if(newList.length < 20){
                            this.noMore = true;
                        }
                        this.img_list = this.img_list.concat(newList);
                    }else{
                        this.$message.error(res.message)
                    }
                }).finally(()=>{
                    this.moreLoading = false;
                })
            },
            changeNav(index){
                if(this.selectType == index) return
                this.selectType = index;
                this.page = 1;
                this.noMore = false;
                this.img_list = [];
                this.$refs.refScroll.scrollTop = 0;
                this.getData();
            },
            selectApplication(img){
                this.$http.patch(`/front/chatai/chatmj/${img.draw_id}/`,{action:'use'})
                this.$emit('select',img);
            },
            previewImg(item){
                this.view_img_url = item.img_url;
                this.$refs.viewPopup.show();
            },
            popClose(){
                this.$refs.viewPopup.close();
            },
            // handleScroll(){
            //     let ch = this.$refs.refScroll.clientHeight;
            //     let sh = this.$refs.refScroll.scrollHeight;
            //     let st = this.$refs.refScroll.scrollTop;
            //     if(sh - ch - st < 200){
            //         this.loadmore();
            //     }
            // },
            loadmore() {
                if(this.moreLoading||this.noMore) return
                this.moreLoading = true;
                this.page++;
                this.getData();
            },
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #toolDrawer{
        width: 320px;
        padding: 0 15px 15px;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .drawer_header{
            display: flex;
            align-items: center;
            height: 60px;
            border-bottom: 1px solid #efeff5;
            flex-shrink: 0;
            .header_icon{
                width: 40px;
                height: 40px;
                border-radius: 20px;
                display: block;
                margin-right: 14px;
                flex-shrink: 0;
            }
            .header_content{
                .header_line_one{
                    color: #333;
                    font-size: 13px;
                    line-height: 23px;
                    .line_tag{
                        padding: 0 7px;
                        color: #f0a020;
                        border-radius: 2px;
                        background-color: #fdf1dd;
                        height: 15px;
                        line-height: 15px;
                        font-size: 11px;
                    }
                }
                .header_line_two{
                    color: #999;
                    font-size: 12px;
                    line-height: 22px;
                }
            }
        }
        .drawer_content_wrapper{
            flex-grow: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            .content_nav{
                flex-shrink: 0;
                line-height: 46px;
                padding-top: 6px;
                display: flex;
                margin-bottom: 15px;
                border-bottom: 1px solid #efeff5;
                justify-content: space-evenly;
                .nav_item{
                    flex-shrink: 0;
                    flex-grow: 0;
                    cursor: pointer;
                    font-size: 13px;
                    position: relative;
                    &.active{
                        color:#18a058;
                        &::after{
                            content: '';
                            display: block;
                            position: absolute;
                            width: 100%;
                            bottom: -1px;
                            left: 0;
                            border-bottom: 1px solid #18a058;
                        }
                    }
                }
            }
            .img_lists{
                flex-grow: 1;
                overflow: hidden;
                overflow-y: scroll;
                margin-right: -17px;
                .vue-waterfall{
                    overflow-y: scroll;
                    margin-right: -17px;
                    width: auto;
                }
                .cell_item{
                    position: relative;
                    overflow: hidden;
                    cursor: pointer;
                    margin-bottom: 10px;
                    // float: left;
                    // width: 140px;
                    // &:nth-of-type(odd){
                    //     margin-right: 10px;
                    // }
                    &:hover{
                        .img_info{
                            bottom: 0;
                        }
                    }
                    .cell_img{
                        display: block;
                        width: 100%;
                    }
                    .img_info{
                        position: absolute;
                        width: 100%;
                        left: 0;
                        bottom: 0px;
                        height: 30px;
                        background-color: rgba(0,0,0,0.6);
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        color: #fff;
                        padding: 0 8px;
                        transition: bottom 0.3s;
                        .info_item{
                            .info_icon{
                                width: 12px;
                                height: 12px;
                                vertical-align: middle;
                                margin-right: 5px;
                                opacity: 1;
                            }
                            span{
                                vertical-align: middle;
                                display: inline-block;
                                font-size: 12px;
                                color: #fff;
                                &.tips{
                                    color: #18a058;
                                }
                            }
                        }
                    }
                }
                .no_more{
                    width: 100%;
                    height: 30px;
                    margin-top: 10px;
                    line-height: 30px;
                    color: #999;
                    font-size: 12px;
                    text-align: center;
                    float: left;
                    span{
                        position: relative;
                        &::before,&::after{
                            content: '';
                            display: block;
                            width: 60px;
                            border-bottom: 1px solid #ccc;
                            position: absolute;
                            top: 50%;
                        }
                        &::before{
                            left: -70px;
                        }
                        &::after{
                            right: -70px;
                        }
                    }
                }
            }
            .img_empty{
                padding-top: 50px;
                .empty_icon{
                    display: block;
                    width: 90px;
                    margin: 0 auto 8px;
                }
                .empty_text{
                    font-size: 11px;
                    color: #d3d3e7;
                    text-align: center;
                }
            }
        }

        .black{
            .content_nav{
                .nav_item{
                    &.active{
                        color:#333;
                        &::after{
                            border-bottom: 1px solid #333;
                        }
                    }
                }
            }
        }
        .view_img{
            display: block;
            max-width: 100%;
            max-height: 100%;
        }
    }
</style>